// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import Antd from 'ant-design-vue'
import './theme/index.less'
import VueI18n from 'vue-i18n'
import LangENUS from './i18n/en-us'
import LangZHCN from './i18n/zh-cn'
import moment from 'moment'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { getCookie } from './util/util.js'
import HTMLDecode from './common/HTMLDecode'
import directives from './common/directives'
import { envConfig } from './common/global'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
axios.defaults.withCredentials = true
axios.defaults.crossDomain = true
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
// axios.defaults.withCredentials = false
Vue.prototype.$http = axios
Vue.prototype.HTMLDecode = HTMLDecode
Vue.config.productionTip = false
Vue.prototype.moment = moment
Vue.use(Antd)
Vue.use(VueI18n)
Vue.use(Viewer)
Vue.use(VueQuillEditor)
Vue.use(directives)

let api
let HallApi
let insuranceApi
let frontUrl
let ssoUrl
const apibx = 'http://192.168.1.186:8870'
Vue.prototype.apibx = apibx
// npm run dev环境
const isHttps = window.location.href.indexOf('https') === -1 ? 'http' : 'https'
if (process.env.NODE_ENV === 'development') {
  api = '/api/'
  HallApi = '/admin/'
  // api = 'http://admin.ems.369zhan.com/'
  // api = 'http://localhost:81/'
  insuranceApi = 'http://192.168.1.24:8870/'
  // insuranceApi = process.env.INSURANCE_URL
  // frontUrl = isHttps + process.env.FRONT_URL
  frontUrl = 'http://localhost:8080/#/'
  ssoUrl = 'http://account.ems-test.369zhan.com/'
  // ssoUrl = 'http://account.369zhan.com/'
  // 编译环境
} else {
  api = isHttps + process.env.BASE_API
  HallApi = isHttps + process.env.BASE_API
  insuranceApi = isHttps + process.env.INSURANCE_URL
  frontUrl = isHttps + process.env.FRONT_URL
  ssoUrl = isHttps + process.env.ssoUrl
}

Vue.prototype.api = api
Vue.prototype.HallApi = HallApi
Vue.prototype.insuranceApi = insuranceApi

// 匿名模板测试环境id
Vue.prototype.$CORD_ID = 1198 // 模板名称:我的新匿名模板
// Vue.prototype.$CORD_ID = process.env.NODE_ENV === 'production' ? 1197 : 1125

// 主场地址
Vue.prototype.frontUrl = frontUrl
Vue.prototype.ssoUrl = ssoUrl

function Decode(response) {
  const json = JSON.stringify(response)
  const res = HTMLDecode.HTMLDecode(json)
  return JSON.parse(res)
}
Vue.prototype.Decode = Decode

/* 拦截器 */
// 添加请求拦截器
axios.interceptors.request.use(
  config => {
    // 在发送请求之前做某事
    if (
      config.url.indexOf('auth/login') > -1 ||
      config.url.indexOf('a/ssoLogin') > -1 ||
      config.url.indexOf('userController/register') > -1 ||
      config.url.indexOf('auth/logout') > -1
    ) {
      config.params = {
        __ajax: true,
        mobileLogin: true,
        nowTime: new Date().valueOf(),
        ...config.params
      }
      return config
    } else {
      config.params = {
        JSESSIONID: getCookie('JSESSIONID'),
        __ajax: true,
        mobileLogin: false,
        nowTime: new Date().valueOf(),
        ...config.params
      }
      return config
    }
  },
  error => {
    // 请求错误时做些事
    return Promise.reject(error)
  }
)

// 添加响应拦截器
axios.interceptors.response.use(
  response => {
    if (response.data.resultCode === -3) {
      if (
        response.data.data.body.requestUrl === '/a/login' ||
        response.data.data.body.requestUrl === '/a/login_ajax' ||
        response.data.data.body.requestUrl === '/a/login?_ajax'
      ) {
        return
      } else if (response.data.data.body.requestUrl === '/a/api/user/get') {
        sessionStorage.removeItem('user')
        sessionStorage.removeItem('booth')
        console.log('user401跳转******')
      } else {
        sessionStorage.removeItem('user')
        sessionStorage.removeItem('booth')

        window.location.href =
          ssoUrl +
          'auth/getVerificationToken?tokenUrl=' +
          window.location.href.split('/#/')[0] +
          `/%23/&platformName=${envConfig.platformName}`
        console.log('401跳转******')
      }
    }
    // http 反转义
    if (
      !response.config.url.split('api/orderPay/payOrder').length ||
      !response.config.url.split('api/orderPay/continuePay').length
    ) {
      const json = JSON.stringify(response)
      const res = HTMLDecode.HTMLDecode(json)
      response = JSON.parse(res)
    }
    return response
  },
  error => {
    const { response } = error
    const { status } = response
    switch (status) {
      case 401:
        sessionStorage.removeItem('user')
        sessionStorage.removeItem('booth')
        window.location.href =
          ssoUrl +
          'auth/getVerificationToken?tokenUrl=' +
          window.location.href.split('/#/')[0] +
          `/%23/&platformName=${envConfig.platformName}`
        break

      default:
        break
    }
    // 请求错误时做些事
    console.log('******************')
    console.log(error)
    return Promise.reject(error)
  }
)
// Viewer默认设置
Viewer.setDefaults({
  Options: {
    inline: false,
    button: true,
    navbar: true,
    title: true,
    toolbar: true,
    tooltip: true,
    movable: true,
    zoomable: true,
    rotatable: true,
    scalable: true,
    transition: true,
    fullscreen: true,
    keyboard: true,
    url: 'data-source'
  }
})

const i18n = new VueI18n({
  locale: 'zh-cn',
  messages: {
    'en-us': LangENUS,
    'zh-cn': LangZHCN
  }
})

// val被格式化的值
// lang  @zh:'@/i18n/zh-cn/dataI18n/
// lang  @en:'@/i18n/en-us/dataI18n/
Vue.filter('dataI18n', (val, lang) => {
  if (sessionStorage.getItem('locale') === 'zh-cn') {
    return lang.zh[val] || val
  } else {
    return lang.en[val] || val
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js